<template>
  <div class="small">
    <radar-chart  ></radar-chart>
    
  </div>
</template>

<script>
  import RadarChart from './RadarChart.js'

  export default {
    components: {
      RadarChart
    },
    
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>